import React from "react";
import { Check } from "lucide-react";
import { WIZARD_STEPS } from "@/lib/constants";

export const Stepper = ({ active, onStepClick, maxReached, steps = WIZARD_STEPS }) => {
  return (
    <div data-testid="wizard-stepper" className="w-full">
      <div className="flex items-center gap-1 overflow-x-auto pb-1 sm:justify-center">
        {steps.map((label, i) => {
          const done = i < active;
          const isActive = i === active;
          const clickable = onStepClick && i <= (maxReached ?? active);
          return (
            <React.Fragment key={label}>
              <button
                type="button"
                disabled={!clickable}
                onClick={() => clickable && onStepClick(i)}
                data-testid={`stepper-step-${i}`}
                className={`flex shrink-0 items-center gap-2 rounded-full px-3 py-1.5 text-xs font-medium transition-colors ${
                  isActive
                    ? "bg-[color:var(--brand-marsala)] text-white"
                    : done
                    ? "text-[color:var(--brand-graphite)]"
                    : "text-[color:var(--brand-muted)]"
                } ${clickable ? "cursor-pointer" : "cursor-default"}`}
              >
                <span
                  className={`flex h-5 w-5 items-center justify-center rounded-full text-[10px] ${
                    isActive
                      ? "bg-white/20 text-white"
                      : done
                      ? "bg-[color:var(--brand-champagne)] text-[color:var(--brand-graphite)]"
                      : "bg-[color:var(--brand-border)] text-[color:var(--brand-muted)]"
                  }`}
                >
                  {done ? <Check className="h-3 w-3" /> : i + 1}
                </span>
                <span className="whitespace-nowrap">{label}</span>
              </button>
              {i < steps.length - 1 && (
                <span className="h-px w-3 shrink-0 bg-[color:var(--brand-border)] sm:w-6" />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};
